import { Injectable } from '@angular/core';

@Injectable()
export class DateService {
  constructor() {}
  private dayString = [
    'lunes',
    'martes',
    'miercoles',
    ' jueves',
    'viernes',
    'sabado',
    'domingo',
  ];

  /**
   * Adds an specific number of days to the specified date
   * @param {Date} date
   * @param {Number} days
   * @return {Date}
   */
  public addDays(date, days) {
    date.setDate(date.getDate() + days);
    return date;
  }

  /**
   * Returns a new date object with the specified quantity of days added
   * @param {Date} date
   * @param {Number} days
   * @return {Date}
   */
  public newDay(date, days) {
    const newDate = new Date(date.valueOf());
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  }

  /**
   * Compare dates checkin ifs old with date today...
   * @param {string} date
   * @return {boolean}
   */
  public checkIfDateIsValid(date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const checkin = new Date(date);
    checkin.setHours(0, 0, 0, 0);
    return today > checkin;
  }

  /**
   * Create the checkin, checkout dates to search default Today
   * @returns {Object}
   */
  public getDatesToday() {
    const from = this.addDays(new Date(), 0).toISOString().split('T')[0];
    const to = this.addDays(new Date(), 1).toISOString().split('T')[0];
    return {
      from: new Date(from.replace(/-/g, '/')),
      to: new Date(to.replace(/-/g, '/')),
    };
  }

  /**
   * Creates a date format YYYY-MM-DD from the exact same date passed
   * @param date
   * @returns {string}
   */
  public parseLiteralDate(date) {
    let zeroPaddedMonth = date.getMonth() + 1;
    zeroPaddedMonth = zeroPaddedMonth < 10 ? '0' + zeroPaddedMonth : zeroPaddedMonth;
    const zeroPaddedDay = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    return date.getFullYear() + '-' + zeroPaddedMonth + '-' + zeroPaddedDay;
  }

  public getDay(date): string {
    const dateObject = new Date(date);
    return this.dayString[dateObject.getDay()];
  }

  public differenceDays(date1: string, date2?: string) {
    const day1 = new Date(date1).getTime();
    const day2 = date2 ? new Date(date2).getTime() : new Date().getTime();

    const difference = Math.abs(day2 - day1);
    return difference / (1000 * 3600 * 24);
  }
}
